/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Acknowledgement: "enum" as const,
	AcknowledgementFilter:{
		equals:"Acknowledgement",
		in:"Acknowledgement",
		not:"AcknowledgementFilter"
	},
	AcknowledgementTemplateFilter:{
		code:"AcknowledgementFilter",
		language:"StringFilter"
	},
	AcknowledgementTemplateOrderBy:{
		revision:"OrderBy"
	},
	AddressInput:{

	},
	AgilityCreditIdVerificationFilter:{
		id:"IDFilter"
	},
	AgilityCreditOfacStatus: "enum" as const,
	AgilityCreditOowDecision: "enum" as const,
	AgilityCreditPrequalReportFilter:{
		bureau:"PrequalBureauFilter",
		id:"IDFilter",
		pId:"StringFilter",
		pullType:"AgilityCreditPullTypeFilter"
	},
	AgilityCreditPullType: "enum" as const,
	AgilityCreditPullTypeFilter:{
		equals:"AgilityCreditPullType",
		in:"AgilityCreditPullType",
		not:"AgilityCreditPullTypeFilter",
		notIn:"AgilityCreditPullType"
	},
	AgilityCreditRedFlagsDecision: "enum" as const,
	AnnouncementOrderBy:{
		createdAt:"OrderBy"
	},
	AssignedStaffOrFilter:{
		bdcId:"IDFilter",
		fniManagerId:"IDFilter",
		salesManagerId:"IDFilter",
		salesPersonId:"IDFilter"
	},
	BigInt: `scalar.BigInt` as const,
	BooleanFilter:{
		not:"BooleanFilter"
	},
	CdkDealJacketStatus: "enum" as const,
	Chat:{
		messages:{

		},
		stagedActions:{

		}
	},
	CheckBoxGroupRules: "enum" as const,
	ComplianceStatus: "enum" as const,
	ContactV2:{
		customers:{

		}
	},
	ContactV2Filter:{
		pId:"IDFilter",
		userId:"IDFilter"
	},
	CreateCustomerInput:{

	},
	CreateEmploymentInput:{

	},
	CreateStaffScheduleEventsInput:{

	},
	CreateUserInput:{

	},
	CreditApplicationAddressInformationInput:{

	},
	CreditApplicationEmploymentInformationInput:{
		employmentStatus:"EmploymentStatus",
		incomeInterval:"IncomeInterval",
		otherIncomeInterval:"IncomeInterval"
	},
	CreditApplicationFormSubmissionDataInput:{

	},
	CreditApplicationFormSubmissionInput:{
		submissionData:"CreditApplicationFormSubmissionDataInput"
	},
	CreditApplicationInput:{
		currentAddress:"CreditApplicationAddressInformationInput",
		currentAddressHousingStatus:"HousingStatus",
		currentEmployment:"CreditApplicationEmploymentInformationInput",
		previousAddress:"CreditApplicationAddressInformationInput",
		previousEmployment:"CreditApplicationEmploymentInformationInput"
	},
	Customer:{
		documents:{
			filter:"DocumentOr"
		},
		employments:{

		},
		formSubmissions:{
			filter:"FormSubmissionFilter"
		},
		hardCreditApplications:{
			filter:"HardCreditApplicationFilter",
			orderBy:"HardCreditApplicationOrderBy"
		},
		livelinessSession:{
			filter:"LivelinessSessionFilter"
		},
		nextDocumentsToSign:{

		},
		ofacChecks:{
			orderBy:"OfacCheckOrderBy"
		},
		oowChecks:{
			orderBy:"OowCheckOrderBy"
		},
		prequalApplications:{

		},
		prescreens:{

		},
		redFlags:{
			orderBy:"RedFlagOrderBy"
		},
		residentialAddresses:{

		}
	},
	CustomerFilter:{
		transactionId:"IDFilter"
	},
	CustomerPurchaseVehicleInput:{
		lifeCycleStage:"VehicleLifeCycleStage",
		principalPriorUse:"VehiclePrincipalPriorUse"
	},
	CustomerSignupInput:{

	},
	CustomerTradeVehicleInput:{
		bodyType:"VehicleBodyType",
		condition:"VehicleCondition"
	},
	CustomerTransactionRole: "enum" as const,
	Date: `scalar.Date` as const,
	DateTime: `scalar.DateTime` as const,
	DateTimeFilter:{
		equals:"DateTime",
		gt:"DateTime",
		gte:"DateTime",
		in:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		not:"DateTimeFilter"
	},
	Dealership:{
		contacts:{
			filter:"ContactV2Filter"
		},
		forms:{

		},
		homenetVehicles:{
			filter:"HomenetVehicleDataFilter"
		},
		staff:{

		},
		transactionStatusUpdateDealershipAnalyticsCount:{
			filter:"TransactionStatusUpdateDealershipAnalyticsFilter"
		},
		transactionUpdateDealershipSpotCount:{
			filter:"TransactionDealershipAnalyticsSpotFilter"
		},
		transactionUpdateStatusSalesRankingGrouped:{
			filter:"TransactionSalesRankingAnalyticsWhereInput"
		},
		transactions:{
			filter:"TransactionFilter",
			orderby:"TransactionOrderBy"
		},
		users:{
			filter:"UserDealershipFilter"
		}
	},
	DealershipFilter:{
		id:"IDFilter",
		slug:"IDFilter"
	},
	DealershipPurchaseVehicleInput:{
		bodyType:"VehicleBodyType",
		lifeCycleStage:"VehicleLifeCycleStage",
		principalPriorUse:"VehiclePrincipalPriorUse"
	},
	DealershipTradeVehicleInput:{
		bodyType:"VehicleBodyType",
		condition:"VehicleCondition",
		lifeCycleStage:"VehicleLifeCycleStage"
	},
	DocumentLabelOrderBy:{
		createdAt:"OrderBy"
	},
	DocumentOr:{
		access:"FormSubmissionAccessEmumFilter",
		dealershipReadAccess:"RoleListFilter",
		id:"IDFilter",
		userId:"IDFilter"
	},
	DocumentOrderBy:{
		createdAt:"OrderBy"
	},
	EmploymentStatus: "enum" as const,
	FieldOrdering: "enum" as const,
	FinanceType: "enum" as const,
	FinanceTypeFilter:{
		equals:"FinanceType",
		in:"FinanceType",
		not:"FinanceTypeFilter"
	},
	Form:{
		formFields:{
			filter:"FormFieldFilter"
		}
	},
	FormCollectionStatus: "enum" as const,
	FormCollectionStatusFilter:{
		equals:"FormCollectionStatus",
		in:"FormCollectionStatus",
		not:"FormCollectionStatusFilter",
		notIn:"FormCollectionStatus"
	},
	FormCollectionType: "enum" as const,
	FormCollectionTypeFilter:{
		equals:"FormCollectionType",
		in:"FormCollectionType",
		not:"FormCollectionTypeFilter",
		notIn:"FormCollectionType"
	},
	FormFieldFilter:{
		isAdminAllowed:"BooleanFilter"
	},
	FormFieldSubmissionAllowedUserFilter:{
		userId:"IDFilter"
	},
	FormFieldSubmissionAllowedUserListFilter:{
		some:"FormFieldSubmissionAllowedUserFilter"
	},
	FormFieldSubmissionFilter:{
		OR:"FormFieldSubmissionOrFilter",
		allowedUsers:"FormFieldSubmissionAllowedUserListFilter",
		field:"FormFieldFilter",
		fileId:"IDFilter",
		formSubmissionId:"IDFilter",
		id:"IDFilter",
		value:"StringFilter"
	},
	FormFieldSubmissionOrFilter:{
		allowedUsers:"FormFieldSubmissionAllowedUserListFilter",
		field:"FormFieldFilter"
	},
	FormFieldSubmissionOrderBy:{
		createdAt:"OrderBy"
	},
	FormFieldType: "enum" as const,
	FormFieldValue:{

	},
	FormRequestErrorCode: "enum" as const,
	FormSubmission:{
		formFieldSubmissions:{
			filter:"FormFieldSubmissionFilter"
		}
	},
	FormSubmissionAccessEmum: "enum" as const,
	FormSubmissionAccessEmumFilter:{
		equals:"FormSubmissionAccessEmum",
		in:"FormSubmissionAccessEmum",
		not:"FormSubmissionAccessEmumFilter",
		notIn:"FormSubmissionAccessEmum"
	},
	FormSubmissionCollection:{
		formSubmissions:{

		}
	},
	FormSubmissionCollectionFilter:{
		id:"IDFilter",
		status:"FormCollectionStatusFilter",
		type:"FormCollectionTypeFilter"
	},
	FormSubmissionCollectionOrderBy:{
		createdAt:"OrderBy"
	},
	FormSubmissionFilter:{
		access:"FormSubmissionAccessEmumFilter",
		id:"IDFilter",
		status:"FormSubmissionStatusFilter",
		type:"FormSubmissionTypeFilter",
		userId:"IDFilter"
	},
	FormSubmissionStatus: "enum" as const,
	FormSubmissionStatusFilter:{
		equals:"FormSubmissionStatus",
		not:"FormSubmissionStatusFilter",
		notIn:"FormSubmissionStatus"
	},
	FormSubmissionType: "enum" as const,
	FormSubmissionTypeFilter:{
		equals:"FormSubmissionType",
		in:"FormSubmissionType",
		not:"FormSubmissionTypeFilter"
	},
	HardCreditApplicationFilter:{
		id:"IDFilter"
	},
	HardCreditApplicationOrderBy:{
		createdAt:"OrderBy"
	},
	HomenetVehicleDataFilter:{
		id:"IDFilter"
	},
	HousingStatus: "enum" as const,
	IDFilter:{
		not:"IDFilter"
	},
	IdCardType: "enum" as const,
	ImageRotation: "enum" as const,
	IncomeInterval: "enum" as const,
	JSON: `scalar.JSON` as const,
	LenderHardCreditApplicationOrderBy:{
		createdAt:"OrderBy"
	},
	LendingPortalAddressEntryInput:{
		housingStatus:"HousingStatus"
	},
	LendingPortalCustomerDataInput:{
		dob:"DateTime"
	},
	LendingPortalEmploymentEntryInput:{
		employmentStatus:"EmploymentStatus",
		incomeInterval:"IncomeInterval",
		otherIncomeInterval:"IncomeInterval"
	},
	LendingPortalPurchaseVehicleDataInput:{
		lifeCycleStage:"VehicleLifeCycleStage"
	},
	LendingPortalTradeVehicleDataInput:{
		lifeCycleStage:"VehicleLifeCycleStage"
	},
	LivelinessSessionFilter:{
		id:"IDFilter"
	},
	LoginOptionType: "enum" as const,
	MeType:{
		chats:{

		}
	},
	Mutation:{
		addScanToDealerJacket:{
			access:"FormSubmissionAccessEmum",
			addTo:"CustomerTransactionRole"
		},
		addScanToGloveCompartments:{

		},
		assignStaffToTransaction:{
			role:"Role"
		},
		cancelFormCollection:{

		},
		cancelPreviousAndRequestSignatures:{
			lifeCycle:"TransactionLifecycle"
		},
		changeDocumentAccess:{
			newAccess:"FormSubmissionAccessEmum"
		},
		changeFormSubmissionAccess:{
			newAccess:"FormSubmissionAccessEmum"
		},
		createAndSubmitCreditAndPrequalApplication:{
			formSubmissionData:"CreditApplicationFormSubmissionInput"
		},
		createChat:{

		},
		createCoBuyer:{
			coBuyer:"CreateCustomerInput"
		},
		createCreditApplicationAndCreateUser:{
			formData:"CreditApplicationInput"
		},
		createEmployment:{
			employment:"CreateEmploymentInput"
		},
		createGroupuser:{
			role:"Role"
		},
		createStaff:{
			user:"CreateUserInput"
		},
		createStaffScheduleEvents:{
			input:"CreateStaffScheduleEventsInput"
		},
		createTransactionAndSubmitTestDrive:{

		},
		createUserFeedback:{

		},
		customerCreatePrefilledTransaction:{
			source:"TransactionSource"
		},
		customerCreatePurchaseVehicle:{
			vehicle:"CustomerPurchaseVehicleInput"
		},
		customerCreateTradeVehicle:{
			vehicle:"CustomerTradeVehicleInput"
		},
		customerCreateTransaction:{
			source:"TransactionSource"
		},
		customerCreateUnauthenticatedTransaction:{
			source:"TransactionSource",
			user:"CreateUserInput"
		},
		customerReferral:{

		},
		customerReferralPaid:{

		},
		customerSignupWithCognito:{
			user:"CustomerSignupInput"
		},
		customerUpdatePhoneNumber:{

		},
		customerUpdatePurchaseVehicle:{
			vehicle:"CustomerPurchaseVehicleInput"
		},
		customerUpdateTradeVehicle:{
			vehicle:"CustomerTradeVehicleInput"
		},
		dealershipCreatePurchaseVehicle:{
			vehicle:"DealershipPurchaseVehicleInput"
		},
		dealershipCreateTradeVehicle:{
			vehicle:"DealershipTradeVehicleInput"
		},
		dealershipCreateTransaction:{
			customer:"CreateCustomerInput",
			staff:"UpdateTransactionStaffInput"
		},
		dealershipRemoveTradeVehicle:{

		},
		dealershipUpdatePurchaseVehicle:{
			vehicle:"DealershipPurchaseVehicleInput"
		},
		dealershipUpdateTradeVehicle:{
			vehicle:"DealershipTradeVehicleInput"
		},
		deleteStaffScheduleEvent:{

		},
		dismissNotifications:{

		},
		extractVehicleFromRegistration:{

		},
		fetchAgilityCreditPrequalReportHtml:{

		},
		finalizeLivenessAnalysis:{

		},
		login:{

		},
		makeUpload:{

		},
		makeUploadForScanner:{
			addTo:"CustomerTransactionRole"
		},
		makeUploadToTransaction:{
			addTo:"CustomerTransactionRole"
		},
		markTransactionAsDelivered:{

		},
		modifyHardCreditApplication:{
			formSubmissionData:"CreditApplicationFormSubmissionInput"
		},
		onboardingSubmitStep1:{
			step1:"SubmitStep1Input"
		},
		onboardingSubmitStep2:{
			step2:"SubmitStep2Input"
		},
		overrideTodo:{

		},
		preLoginCheck:{

		},
		prefillLicensePlateOrVin:{

		},
		pushDataToCrms:{

		},
		pushDocumentToCdkDealJacket:{

		},
		pushDocumentsToCdk:{

		},
		pushFormSubmissionsToCdk:{

		},
		pushHardCreditApplication:{
			submitTo:"SubmitTo"
		},
		recordChatNavigation:{

		},
		recordConsent:{

		},
		removeCoBuyer:{

		},
		removePrimaryBuyer:{

		},
		requestAgilityCreditOfac:{

		},
		requestAgilityCreditOow:{

		},
		requestAgilityCreditPrequal:{
			bureaus:"PrequalBureau",
			pullType:"AgilityCreditPullType"
		},
		requestAgilityCreditRedFlags:{

		},
		requestIdentityVerification:{

		},
		requestOtpExistingUserDEV:{

		},
		requestPrequalReports:{
			bureaus:"PrequalBureau"
		},
		requestPrescreen:{

		},
		resendStaffPassword:{

		},
		resolveStagedAction:{

		},
		saveLendingPortalCustomerData:{
			addressEntries:"LendingPortalAddressEntryInput",
			customerData:"LendingPortalCustomerDataInput",
			employmentEntries:"LendingPortalEmploymentEntryInput"
		},
		saveLendingPortalPurchaseVehicleData:{
			vehicleData:"LendingPortalPurchaseVehicleDataInput"
		},
		saveLendingPortalTradeVehicleData:{
			tradeVehicleData:"LendingPortalTradeVehicleDataInput"
		},
		sendChatMessage:{

		},
		sendFormReadyNotifications:{

		},
		setDeliveryMethodForUser:{

		},
		setDocumentLabels:{

		},
		setDocumentTitle:{

		},
		setStaffInformation:{
			staffInformation:"SetStaffInformationInput"
		},
		setStaffPlanningEnabled:{

		},
		stageAdditionalForms:{
			forms:"StageFormInput"
		},
		startLivenessAnalysis:{

		},
		submitAgilityCreditOowAnswers:{

		},
		submitFormValues:{
			values:"FormFieldValue"
		},
		submitPrequalApplicationAndCreateUser:{
			formData:"PrequalInput"
		},
		submitPrequalApplicationOnTransaction:{
			formData:"PrequalInput"
		},
		submitStaffAcknowledgement:{

		},
		submitStandardForm:{
			type:"FormSubmissionType"
		},
		suspendGroupUser:{

		},
		suspendStaff:{

		},
		switchCustomerRoles:{

		},
		testDriveEnsureCustomerForDealership:{

		},
		trackUserEvent:{
			operation:"UserEventOperation"
		},
		unlockTransaction:{

		},
		updateCustomer:{
			customer:"UpdateCustomerInput"
		},
		updateEmployment:{
			employment:"UpdateEmploymentInput"
		},
		updateGroupUser:{
			role:"Role"
		},
		updateIdCardRotation:{
			captureBackRotation:"ImageRotation",
			captureFrontRotation:"ImageRotation"
		},
		updateMyUser:{
			user:"UpdateUserInput"
		},
		updateReceivesAuthenticomReport:{

		},
		updateStaffAttributes:{
			attributes:"StaffAttributes"
		},
		updateStaffExtraPermissions:{
			extraPermissions:"Permission"
		},
		updateStaffScheduleEvent:{
			input:"UpdateStaffScheduleEventInput"
		},
		updateTradeVehicleIntent:{
			intent:"TradeVehicleIntent"
		},
		updateTransaction:{
			transaction:"UpdateTransactionInput"
		},
		uploadAdditionalDocuments:{

		},
		uploadAdditionalDocumentsToTransaction:{
			access:"FormSubmissionAccessEmum",
			addTo:"CustomerTransactionRole"
		},
		uploadIdCard:{
			idCardType:"IdCardType"
		},
		uploadIdCardWithToken:{
			idCardType:"IdCardType"
		},
		userExists:{

		},
		verifyOtpForExistingUser:{

		}
	},
	NotificationFilter:{
		announcementId:"IDFilter",
		createdAt:"DateTimeFilter",
		dismissedAt:"DateTimeFilter"
	},
	NotificationOrderBy:{
		createdAt:"OrderBy",
		dismissedAt:"OrderBy"
	},
	OfacCheckOrderBy:{
		createdAt:"OrderBy"
	},
	OfacCheckSource: "enum" as const,
	OfacCheckStatus: "enum" as const,
	OnboardingStep: "enum" as const,
	OowCheckOrderBy:{
		createdAt:"OrderBy"
	},
	OowCheckSource: "enum" as const,
	OowCheckStatus: "enum" as const,
	OrderBy: "enum" as const,
	Permission: "enum" as const,
	PlatformType:{
		announcements:{
			orderBy:"AnnouncementOrderBy"
		},
		documentLabels:{
			orderBy:"DocumentLabelOrderBy"
		},
		faqs:{

		},
		isIpBlocked:{

		},
		isUserSuspended:{

		}
	},
	PolicyLayerType: "enum" as const,
	PrequalApplication:{
		agilityCreditPrequalReports:{
			filter:"AgilityCreditPrequalReportFilter"
		},
		prequalResponses:{
			filter:"SevenHundredCreditPrequalReportsFilter"
		}
	},
	PrequalBureau: "enum" as const,
	PrequalBureauFilter:{
		equals:"PrequalBureau",
		in:"PrequalBureau",
		not:"PrequalBureauFilter",
		notIn:"PrequalBureau"
	},
	PrequalInput:{

	},
	PublicType:{
		acknowledgements:{
			filter:"AcknowledgementTemplateFilter",
			orderBy:"AcknowledgementTemplateOrderBy"
		}
	},
	Query:{
		customer:{

		},
		dealership:{

		},
		dealershipStaffScheduleEvents:{

		},
		node:{

		},
		nodes:{

		},
		transaction:{

		},
		userDealership:{

		}
	},
	RecallMastersRecallReportFilter:{
		id:"IDFilter"
	},
	RecallMastersRecallReportOrderBy:{
		createdAt:"OrderBy"
	},
	RedFlagOrderBy:{
		createdAt:"OrderBy"
	},
	RedFlagSource: "enum" as const,
	RedFlagStatus: "enum" as const,
	ReferralStatus: "enum" as const,
	Role: "enum" as const,
	RoleFilter:{
		equals:"Role",
		in:"Role",
		not:"RoleFilter"
	},
	RoleListFilter:{
		has:"Role"
	},
	SetStaffInformationInput:{

	},
	SevenHundredCreditPrequalReportsFilter:{
		bureau:"PrequalBureauFilter",
		id:"IDFilter"
	},
	StaffAttributes:{
		role:"Role"
	},
	StaffFilter:{
		dealershipId:"IDFilter",
		id:"IDFilter"
	},
	StaffInformationFilter:{
		dealershipId:"IDFilter",
		id:"IDFilter"
	},
	StageFormInput:{

	},
	StringFilter:{
		mode:"StringFilterMode",
		not:"StringFilter"
	},
	StringFilterMode: "enum" as const,
	SubmitStep1Input:{

	},
	SubmitStep2Input:{

	},
	SubmitTo: "enum" as const,
	TextAlignment: "enum" as const,
	TodoFilter:{
		createdAt:"DateTimeFilter",
		status:"TodoStatusFilter",
		transactionId:"IDFilter",
		type:"TodoTypesFilter"
	},
	TodoOrderBy:{
		createdAt:"OrderBy"
	},
	TodoStatus: "enum" as const,
	TodoStatusFilter:{
		equals:"TodoStatus",
		in:"TodoStatus",
		not:"TodoStatusFilter"
	},
	TodoTypes: "enum" as const,
	TodoTypesFilter:{
		equals:"TodoTypes",
		in:"TodoTypes",
		not:"TodoTypesFilter"
	},
	TradeVehicleIntent: "enum" as const,
	Transaction:{
		agilityCreditVerifications:{
			filter:"AgilityCreditIdVerificationFilter"
		},
		documents:{
			filter:"DocumentOr",
			orderBy:"DocumentOrderBy"
		},
		formSubmissionCollections:{
			filter:"FormSubmissionCollectionFilter",
			orderBy:"FormSubmissionCollectionOrderBy"
		},
		formSubmissions:{
			filter:"FormSubmissionFilter",
			orderBy:"FormFieldSubmissionOrderBy"
		},
		lenderHardCreditApplications:{
			orderBy:"LenderHardCreditApplicationOrderBy"
		},
		logs:{
			filter:"TransactionLogFilter",
			orderBy:"TransactionLogOrderBy"
		},
		referrals:{

		},
		todos:{
			filter:"TodoFilter",
			orderBy:"TodoOrderBy"
		},
		vehicleRegistrationExtractions:{
			filter:"VehicleRegistrationExtractionFilter"
		}
	},
	TransactionAndFilter:{
		OR:"AssignedStaffOrFilter",
		salesPersonId:"IDFilter"
	},
	TransactionDealershipAnalyticsSpotFilter:{
		eventAt:"DateTimeFilter"
	},
	TransactionFilter:{
		AND:"TransactionAndFilter",
		OR:"AssignedStaffOrFilter",
		buyerId:"IDFilter",
		coBuyerId:"IDFilter",
		createdAt:"DateTimeFilter",
		dealership:"DealershipFilter",
		id:"IDFilter",
		salesPersonId:"IDFilter",
		source:"TransactionSourceFilter",
		status:"TransactionStatusFilter"
	},
	TransactionLifecycle: "enum" as const,
	TransactionLockReason: "enum" as const,
	TransactionLogFilter:{
		createdAt:"DateTimeFilter",
		executingUserId:"IDFilter"
	},
	TransactionLogOrderBy:{
		createdAt:"OrderBy"
	},
	TransactionOrderBy:{
		createdAt:"FieldOrdering",
		firstName:"FieldOrdering",
		lastName:"FieldOrdering",
		source:"FieldOrdering",
		status:"FieldOrdering"
	},
	TransactionRole: "enum" as const,
	TransactionSalesRankingAnalyticsWhereInput:{
		status:"TransactionStatusFilter"
	},
	TransactionSource: "enum" as const,
	TransactionSourceFilter:{
		equals:"TransactionSource",
		in:"TransactionSource",
		not:"TransactionSourceFilter"
	},
	TransactionStatus: "enum" as const,
	TransactionStatusFilter:{
		equals:"TransactionStatus",
		in:"TransactionStatus",
		not:"TransactionStatusFilter"
	},
	TransactionStatusUpdateDealershipAnalyticsFilter:{
		eventAt:"DateTimeFilter",
		financeType:"FinanceTypeFilter",
		purchaseVehicleLifeCycleStage:"VehicleLifeCycleStageFilter",
		source:"TransactionSourceFilter",
		status:"TransactionStatusFilter"
	},
	UpdateCustomerAddress:{

	},
	UpdateCustomerInput:{
		dob:"DateTime",
		residentialAddresses:"AddressInput",
		vehicleRegistrationAddress:"UpdateCustomerAddress"
	},
	UpdateEmploymentInput:{

	},
	UpdateStaffScheduleEventInput:{

	},
	UpdateTransactionInput:{

	},
	UpdateTransactionStaffInput:{

	},
	UpdateUserInput:{

	},
	User:{
		buyerFor:{
			filter:"TransactionFilter"
		},
		coBuyerFor:{
			filter:"TransactionFilter"
		},
		customers:{
			filter:"CustomerFilter"
		},
		hasReferred:{

		},
		notifications:{
			filter:"NotificationFilter",
			orderBy:"NotificationOrderBy"
		},
		staff:{
			filter:"StaffFilter"
		},
		staffInformation:{
			filter:"StaffInformationFilter"
		},
		userAcknowledgements:{
			filter:"UserAcknowledgementFilter",
			order:"UserAcknowledgementOrderBy"
		},
		userGroup:{
			filter:"UserGroupFilter"
		},
		userLogs:{

		}
	},
	UserAcknowledgementFilter:{
		acknowledgementId:"IDFilter",
		dealershipId:"IDFilter",
		transactionId:"IDFilter"
	},
	UserAcknowledgementOrderBy:{
		createdAt:"OrderBy"
	},
	UserDealershipFilter:{
		isSuspended:"BooleanFilter",
		role:"RoleFilter",
		user:"UserFilter",
		userId:"IDFilter"
	},
	UserEventOperation: "enum" as const,
	UserFilter:{
		OR:"UserOrFilter",
		firstName:"StringFilter",
		lastName:"StringFilter"
	},
	UserGroupFilter:{

	},
	UserOrFilter:{
		firstName:"StringFilter",
		id:"IDFilter",
		lastName:"StringFilter"
	},
	Vehicle:{
		recallMastersRecallReports:{
			filter:"RecallMastersRecallReportFilter",
			orderBy:"RecallMastersRecallReportOrderBy"
		},
		vehicleRecallChecks:{
			filter:"VehicleNhtsaRecallReportFilter",
			orderby:"VehicleNhtsaRecallReportOrderBy"
		},
		vinAuditReports:{
			filter:"VinAuditReportFilter",
			orderby:"VinAuditReportOrderBy"
		}
	},
	VehicleBodyType: "enum" as const,
	VehicleCondition: "enum" as const,
	VehicleLifeCycleStage: "enum" as const,
	VehicleLifeCycleStageFilter:{
		equals:"VehicleLifeCycleStage",
		in:"VehicleLifeCycleStage",
		not:"VehicleLifeCycleStageFilter"
	},
	VehicleNhtsaRecallReportFilter:{
		id:"IDFilter"
	},
	VehicleNhtsaRecallReportOrderBy:{
		createdAt:"OrderBy"
	},
	VehiclePrincipalPriorUse: "enum" as const,
	VehicleRegistrationExtractionFilter:{
		id:"IDFilter"
	},
	VehicleRegistrationExtractionStatus: "enum" as const,
	VinAuditReportFilter:{
		id:"IDFilter"
	},
	VinAuditReportOrderBy:{
		createdAt:"OrderBy"
	},
	ID: `scalar.ID` as const
}

export const ReturnTypes: Record<string,any> = {
	AcknowledgementTemplate:{
		code:"Acknowledgement",
		createdAt:"DateTime",
		id:"String",
		language:"String",
		revision:"Int",
		textMarkdown:"String"
	},
	Address:{
		apartmentDetails:"String",
		city:"String",
		customer:"Customer",
		durationMonths:"Int",
		durationYears:"Int",
		fullAddress:"String",
		housingStatus:"HousingStatus",
		id:"String",
		monthlyPayment:"Float",
		state:"String",
		street:"String",
		timelinePosition:"Int",
		transactionId:"String",
		userId:"String",
		zipCode:"String"
	},
	AgentStagedAction:{
		createdAt:"DateTime",
		error:"String",
		id:"String",
		kind:"String",
		payload:"JSON",
		status:"String",
		summary:"String"
	},
	AgilityCreditIdVerification:{
		id:"String",
		idCard:"IdCard",
		response:"JSON"
	},
	AgilityCreditOfacCheck:{
		createdAt:"DateTime",
		errorMessage:"String",
		id:"String",
		status:"AgilityCreditOfacStatus",
		statusDescription:"String"
	},
	AgilityCreditOowCheck:{
		createdAt:"DateTime",
		errorMessage:"String",
		finalDecision:"AgilityCreditOowDecision",
		id:"String",
		initialDecision:"AgilityCreditOowDecision",
		outWalletScore:"Int",
		preciseidScore:"Int",
		questions:"AgilityCreditOowQuestion",
		sessionId:"String"
	},
	AgilityCreditOowQuestion:{
		choices:"String",
		correct:"Boolean",
		id:"String",
		isCreditBased:"Boolean",
		position:"Int",
		question:"String",
		submittedAnswer:"String",
		weight:"Int"
	},
	AgilityCreditPrequalReport:{
		bureau:"PrequalBureau",
		createdAt:"DateTime",
		creditScore:"Int",
		creditScoreModel:"String",
		errorMessage:"String",
		isLoading:"Boolean",
		pId:"String",
		pullType:"AgilityCreditPullType",
		stage:"String"
	},
	AgilityCreditRedFlagsCheck:{
		createdAt:"DateTime",
		decision:"AgilityCreditRedFlagsDecision",
		decisionOverride:"Boolean",
		errorMessage:"String",
		fpdScore:"Int",
		id:"String",
		ienScore:"Int",
		preciseIdScore:"Int",
		preciseMatchScore:"Int",
		referenceId:"String",
		sessionId:"String",
		syntheticIdDetectionScore:"Int",
		syntheticIdHighRiskScore:"Int",
		validationScore:"Int",
		verificationScore:"Int"
	},
	AgilityCreditReportHtml:{
		html:"String"
	},
	Announcement:{
		createdAt:"DateTime",
		id:"String",
		markdownText:"String"
	},
	BigInt: `scalar.BigInt` as const,
	Chat:{
		createdAt:"DateTime",
		humanTakenOver:"Boolean",
		id:"String",
		killedAt:"DateTime",
		messages:"ChatMessagesConnection",
		pId:"String",
		stagedActions:"ChatStagedActionsConnection",
		title:"String",
		updatedAt:"DateTime"
	},
	ChatMessage:{
		createdAt:"DateTime",
		id:"String",
		message:"JSON",
		updatedAt:"DateTime"
	},
	ChatMessagesConnection:{
		edges:"ChatMessagesConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	ChatMessagesConnectionEdge:{
		cursor:"String",
		node:"ChatMessage"
	},
	ChatStagedActionsConnection:{
		edges:"ChatStagedActionsConnectionEdge",
		pageInfo:"PageInfo"
	},
	ChatStagedActionsConnectionEdge:{
		cursor:"String",
		node:"AgentStagedAction"
	},
	CheckBoxGroup:{
		id:"String",
		label:"String",
		n:"Int",
		rule:"CheckBoxGroupRules"
	},
	ComplianceData:{
		hasRequestedIdv:"ComplianceIdvField",
		id:"ComplianceField",
		idQuizSummary:"ComplianceField",
		ofacStatus:"ComplianceField",
		recalls:"ComplianceField",
		redFlagStatus:"ComplianceField"
	},
	ComplianceField:{
		description:"String",
		status:"ComplianceStatus",
		title:"String"
	},
	ComplianceFormsData:{
		lendingPortalPreCondition:"ComplianceFormsPreCondition",
		postPurchaseForms:"Form",
		postPurchasePreCondition:"ComplianceFormsPreCondition",
		prePurchaseForms:"Form",
		prePurchasePreCondition:"ComplianceFormsPreCondition"
	},
	ComplianceFormsPreCondition:{
		errorCodes:"FormRequestErrorCode",
		result:"Boolean"
	},
	ComplianceIdvField:{
		description:"String",
		hasIdCard:"Boolean",
		hasRequestedVerification:"Boolean",
		latestVerificationId:"String",
		status:"ComplianceStatus",
		title:"String"
	},
	ContactV2:{
		createdAt:"DateTime",
		customers:"ContactV2CustomersConnection",
		firstName:"String",
		id:"String",
		lastName:"String",
		middleName:"String",
		pId:"String",
		profilePicture:"File",
		updatedAt:"DateTime",
		user:"User",
		userId:"String"
	},
	ContactV2CustomersConnection:{
		edges:"ContactV2CustomersConnectionEdge",
		pageInfo:"PageInfo"
	},
	ContactV2CustomersConnectionEdge:{
		cursor:"String",
		node:"Customer"
	},
	Customer:{
		agilityApplicantUrl:"String",
		birthdate:"String",
		compliance:"ComplianceData",
		contact:"ContactV2",
		contactAcknowledgement:"FormSubmission",
		createdAt:"DateTime",
		dealership:"Dealership",
		disassociatedRole:"String",
		dob:"String",
		documents:"CustomerDocumentsConnection",
		employments:"CustomerEmploymentsConnection",
		firstName:"String",
		formSubmissions:"CustomerFormSubmissionsConnection",
		hardCreditApplications:"CustomerHardCreditApplicationsConnection",
		hasBeenRemovedFromTransaction:"Boolean",
		hasPrequalApplication:"Boolean",
		hasSubmittedHardCreditApplication:"Boolean",
		idCards:"IdCard",
		identityTheftPrevention:"FormSubmission",
		languageSelection:"String",
		lastName:"String",
		lastRequestedPrescreenAt:"DateTime",
		livelinessSession:"CustomerLivelinessSessionConnection",
		middleName:"String",
		nextDocumentsToSign:"CustomerNextDocumentsToSignConnection",
		ofacChecks:"CustomerOfacChecksConnection",
		onboardingStep:"OnboardingStep",
		oowChecks:"CustomerOowChecksConnection",
		prequalApplications:"CustomerPrequalApplicationsConnection",
		prescreens:"CustomerPrescreensConnection",
		privacyPolicy:"FormSubmission",
		redFlags:"CustomerRedFlagsConnection",
		residentialAddresses:"CustomerResidentialAddressesConnection",
		selfieCapture:"File",
		socialSecurityNumber:"String",
		testDriveDisclosure:"FormSubmission",
		transaction:"Transaction",
		transactionId:"String",
		user:"User",
		userId:"String",
		vehicleRegistrationAddress:"Address",
		vehicleRegistrationAddressId:"String"
	},
	CustomerDocumentsConnection:{
		edges:"CustomerDocumentsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	CustomerDocumentsConnectionEdge:{
		cursor:"String",
		node:"Document"
	},
	CustomerEmploymentsConnection:{
		edges:"CustomerEmploymentsConnectionEdge",
		pageInfo:"PageInfo"
	},
	CustomerEmploymentsConnectionEdge:{
		cursor:"String",
		node:"Employment"
	},
	CustomerFormSubmissionsConnection:{
		edges:"CustomerFormSubmissionsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	CustomerFormSubmissionsConnectionEdge:{
		cursor:"String",
		node:"FormSubmission"
	},
	CustomerHardCreditApplicationsConnection:{
		edges:"CustomerHardCreditApplicationsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	CustomerHardCreditApplicationsConnectionEdge:{
		cursor:"String",
		node:"HardCreditApplication"
	},
	CustomerLivelinessSessionConnection:{
		edges:"CustomerLivelinessSessionConnectionEdge",
		pageInfo:"PageInfo"
	},
	CustomerLivelinessSessionConnectionEdge:{
		cursor:"String",
		node:"LivelinessSession"
	},
	CustomerNextDocumentsToSignConnection:{
		edges:"CustomerNextDocumentsToSignConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	CustomerNextDocumentsToSignConnectionEdge:{
		cursor:"String",
		node:"FormSubmission"
	},
	CustomerOfacChecksConnection:{
		edges:"CustomerOfacChecksConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	CustomerOfacChecksConnectionEdge:{
		cursor:"String",
		node:"OfacCheck"
	},
	CustomerOowChecksConnection:{
		edges:"CustomerOowChecksConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	CustomerOowChecksConnectionEdge:{
		cursor:"String",
		node:"OowCheck"
	},
	CustomerPrequalApplicationsConnection:{
		edges:"CustomerPrequalApplicationsConnectionEdge",
		pageInfo:"PageInfo"
	},
	CustomerPrequalApplicationsConnectionEdge:{
		cursor:"String",
		node:"PrequalApplication"
	},
	CustomerPrescreensConnection:{
		edges:"CustomerPrescreensConnectionEdge",
		pageInfo:"PageInfo"
	},
	CustomerPrescreensConnectionEdge:{
		cursor:"String",
		node:"Prescreen"
	},
	CustomerRedFlagsConnection:{
		edges:"CustomerRedFlagsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	CustomerRedFlagsConnectionEdge:{
		cursor:"String",
		node:"RedFlag"
	},
	CustomerResidentialAddressesConnection:{
		edges:"CustomerResidentialAddressesConnectionEdge",
		pageInfo:"PageInfo"
	},
	CustomerResidentialAddressesConnectionEdge:{
		cursor:"String",
		node:"Address"
	},
	CustomerSharedData:{
		buyerEmail:"String",
		buyerFirstName:"String",
		buyerLastName:"String",
		buyerName:"String",
		buyerOnboardingStep:"OnboardingStep",
		buyerPhoneNumber:"String",
		coBuyerEmail:"String",
		coBuyerFirstName:"String",
		coBuyerLastName:"String",
		coBuyerName:"String",
		coBuyerOnboardingStep:"OnboardingStep",
		coBuyerPhoneNumber:"String"
	},
	Date: `scalar.Date` as const,
	DateTime: `scalar.DateTime` as const,
	Dealership:{
		address:"String",
		contacts:"DealershipContactsConnection",
		dealershipGroupId:"String",
		enabledPolicyLayers:"PolicyLayerType",
		forms:"DealershipFormsConnection",
		hasActiveAgilityCreditSubscription:"Boolean",
		hasActiveSevenHundredCreditPrequalSubscription:"Boolean",
		hasEnabledAuthenticom:"Boolean",
		hasEnabledCdkCrm:"Boolean",
		hasEnabledCdkDms:"Boolean",
		hasEnabledChatBot:"Boolean",
		hasEnabledComplianceForms:"Boolean",
		hasEnabledDealJacketGalleryView:"Boolean",
		hasEnabledDealerTrack:"Boolean",
		hasEnabledDriversLicenseVerification:"Boolean",
		hasEnabledFormsCatalog:"Boolean",
		hasEnabledIdVerifOverAgility:"Boolean",
		hasEnabledImplicitPrequalsOnHca:"Boolean",
		hasEnabledPostPurchaseDocs:"Boolean",
		hasEnabledPrequalFormService:"Boolean",
		hasEnabledPrescreen:"Boolean",
		hasEnabledRecallMasters:"Boolean",
		hasEnabledReferrals:"Boolean",
		hasEnabledReportingDashboard:"Boolean",
		hasEnabledRoute1:"Boolean",
		hasEnabledStaffAcknowledgement:"Boolean",
		hasEnabledStaffPlanning:"Boolean",
		hasEnabledZipCodeOnSignUp:"Boolean",
		hasTdcCdkAppSubscriptionId:"Boolean",
		homenetVehicles:"DealershipHomenetVehiclesConnection",
		id:"String",
		logoUrl:"String",
		name:"String",
		phone:"String",
		postPurchaseBillOfSaleFormId:"String",
		postPurchasePurchaseOrderFormId:"String",
		recallDetailsFormId:"String",
		recallSummaryFormId:"String",
		referralPayoutAmountInUsdCents:"Int",
		salesPeople:"ListItem",
		slug:"String",
		staff:"DealershipStaffConnection",
		supportedLanguages:"String",
		timeZone:"String",
		transactionStatusUpdateDealershipAnalyticsCount:"Int",
		transactionUpdateDealershipSpotCount:"Int",
		transactionUpdateStatusSalesRankingGrouped:"SalesRankingGrouppedByMonth",
		transactions:"DealershipTransactionsConnection",
		users:"DealershipUsersConnection",
		website:"String"
	},
	DealershipContactsConnection:{
		edges:"DealershipContactsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	DealershipContactsConnectionEdge:{
		cursor:"String",
		node:"ContactV2"
	},
	DealershipFormsConnection:{
		edges:"DealershipFormsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	DealershipFormsConnectionEdge:{
		cursor:"String",
		node:"Form"
	},
	DealershipGroup:{
		address:"String",
		id:"String",
		name:"String",
		phoneNumber:"String"
	},
	DealershipHomenetVehiclesConnection:{
		edges:"DealershipHomenetVehiclesConnectionEdge",
		pageInfo:"PageInfo"
	},
	DealershipHomenetVehiclesConnectionEdge:{
		cursor:"String",
		node:"HomenetVehicleData"
	},
	DealershipPermType:{
		dealershipGroupId:"String",
		dealershipGroupName:"String",
		dealershipId:"String",
		dealershipName:"String",
		extraPermissions:"Permission",
		groupRole:"Role",
		role:"Role"
	},
	DealershipStaffConnection:{
		edges:"DealershipStaffConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	DealershipStaffConnectionEdge:{
		cursor:"String",
		node:"Staff"
	},
	DealershipTransactionsConnection:{
		edges:"DealershipTransactionsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	DealershipTransactionsConnectionEdge:{
		cursor:"String",
		node:"Transaction"
	},
	DealershipUsersConnection:{
		edges:"DealershipUsersConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	DealershipUsersConnectionEdge:{
		cursor:"String",
		node:"UserDealership"
	},
	Document:{
		access:"String",
		cdkDealJacketStatus:"CdkDealJacketStatus",
		createdAt:"DateTime",
		customer:"Customer",
		file:"File",
		id:"String",
		labels:"DocumentLabelAttachment",
		pdfIsEncrypted:"Boolean",
		title:"String",
		transactionId:"String",
		userId:"String"
	},
	DocumentLabel:{
		code:"String",
		id:"String",
		label:"String"
	},
	DocumentLabelAttachment:{
		documentLabel:"DocumentLabel",
		isActive:"Boolean"
	},
	Employment:{
		customer:"Customer",
		durationMonths:"Int",
		durationYears:"Int",
		employerName:"String",
		employerPhoneNumber:"String",
		employmentStatus:"EmploymentStatus",
		id:"String",
		incomeAmount:"Float",
		incomeInterval:"IncomeInterval",
		occupation:"String",
		otherIncomeAmount:"Float",
		otherIncomeInterval:"IncomeInterval",
		otherIncomeSource:"String",
		timelinePosition:"Int",
		transactionId:"String",
		userId:"String"
	},
	Faq:{
		answer:"String",
		createdAt:"DateTime",
		dealershipGroupId:"String",
		dealershipId:"String",
		id:"String",
		question:"String",
		updatedAt:"DateTime"
	},
	File:{
		id:"String",
		uploader:"User",
		url:"String"
	},
	Form:{
		accessType:"String",
		createdAt:"DateTime",
		displayTitle:"String",
		formFields:"FormField",
		formOrder:"FormOrder",
		id:"String",
		pdfFileUrl:"String"
	},
	FormField:{
		characterListLength:"Int",
		checkboxGroup:"CheckBoxGroup",
		createdAt:"DateTime",
		demoData:"String",
		enteredBy:"TransactionRole",
		fixedValue:"String",
		form:"Form",
		formFieldId:"String",
		formFieldPlacements:"FormFieldPlacement",
		formId:"String",
		id:"String",
		isAdminAllowed:"Boolean",
		isOptional:"Boolean",
		prefillPath:"String",
		type:"FormFieldType"
	},
	FormFieldPlacement:{
		characterListSpacing:"Float",
		createdAt:"DateTime",
		formField:"FormField",
		formFieldId:"String",
		formFieldPlacementId:"String",
		height:"Float",
		id:"String",
		page:"Int",
		positionX:"Float",
		positionY:"Float",
		textAlignment:"TextAlignment",
		textBold:"Boolean",
		textFontSize:"Float",
		textItalic:"Boolean",
		textLineHeight:"Float",
		textUnderline:"Boolean",
		width:"Float"
	},
	FormFieldSubmission:{
		field:"FormField",
		fieldId:"ID",
		file:"File",
		formSubmission:"FormSubmission",
		value:"String"
	},
	FormOrder:{
		position:"Int"
	},
	FormSubmission:{
		access:"String",
		cdkDealJacketStatus:"CdkDealJacketStatus",
		createdAt:"DateTime",
		customer:"Customer",
		file:"File",
		fileId:"String",
		form:"Form",
		formCollection:"FormSubmissionCollection",
		formFieldSubmissions:"FormSubmissionFormFieldSubmissionsConnection",
		formSubmissionData:"String",
		id:"String",
		status:"String",
		type:"String",
		userId:"String"
	},
	FormSubmissionCollection:{
		createdAt:"DateTime",
		formSubmissions:"FormSubmissionCollectionFormSubmissionsConnection",
		id:"String",
		isCollectionStale:"Boolean",
		status:"FormCollectionStatus",
		type:"FormCollectionType"
	},
	FormSubmissionCollectionFormSubmissionsConnection:{
		edges:"FormSubmissionCollectionFormSubmissionsConnectionEdge",
		pageInfo:"PageInfo"
	},
	FormSubmissionCollectionFormSubmissionsConnectionEdge:{
		cursor:"String",
		node:"FormSubmission"
	},
	FormSubmissionFormFieldSubmissionsConnection:{
		edges:"FormSubmissionFormFieldSubmissionsConnectionEdge",
		pageInfo:"PageInfo"
	},
	FormSubmissionFormFieldSubmissionsConnectionEdge:{
		cursor:"String",
		node:"FormFieldSubmission"
	},
	GraphQLError:{
		message:"String"
	},
	HardCreditApplication:{
		createdAt:"DateTime",
		dob:"Date",
		driversLicenseNumber:"String",
		driversLicenseState:"String",
		email:"String",
		employments:"JSON",
		firstName:"String",
		formSubmission:"FormSubmission",
		formSubmissionId:"String",
		homePhoneNumber:"String",
		housingCostUsdCents:"BigInt",
		id:"String",
		incomeInterval:"IncomeInterval",
		incomeUsdCents:"BigInt",
		lastName:"String",
		middleName:"String",
		personalReferenceAddress:"Address",
		personalReferenceAddressId:"String",
		personalReferenceFirstName:"String",
		personalReferenceLastName:"String",
		personalReferenceMiddleName:"String",
		personalReferencePhoneNumber:"String",
		personalReferenceRelationship:"String",
		phoneNumber:"String",
		residentialAddresses:"JSON",
		socialSecurityNumber:"String",
		transaction:"Transaction",
		transactionId:"String",
		user:"User",
		userId:"String"
	},
	HomenetVehicleData:{
		bodyType:"String",
		color:"String",
		dealerId:"String",
		fuelType:"String",
		id:"String",
		locationId:"String",
		make:"String",
		mileage:"String",
		model:"String",
		msrp:"String",
		rooftopId:"String",
		stockNumber:"String",
		transmission:"String",
		trim:"String",
		type:"String",
		vehicleId:"String",
		vin:"String",
		year:"String"
	},
	IdCard:{
		captureBack:"File",
		captureBackId:"String",
		captureBackRotation:"ImageRotation",
		captureFront:"File",
		captureFrontId:"String",
		captureFrontRotation:"ImageRotation",
		cityInAddress:"String",
		class:"String",
		createdAt:"DateTime",
		dob:"DateTime",
		dobDateOnly:"Date",
		expirationDate:"DateTime",
		expirationDateOnly:"Date",
		eyeColor:"String",
		firstName:"String",
		height:"String",
		id:"String",
		idNumber:"String",
		issueDate:"DateTime",
		issueDateOnly:"Date",
		lastName:"String",
		middleName:"String",
		requestedIdVerificationAt:"DateTime",
		sex:"String",
		state:"String",
		stateInAddress:"String",
		streetInAddress:"String",
		suffix:"String",
		transactionId:"String",
		type:"String",
		userId:"String",
		zipCodeInAddress:"String"
	},
	JSON: `scalar.JSON` as const,
	LenderHardCreditApplication:{
		buyerHousingCostCents:"BigInt",
		buyerIncomeCents:"BigInt",
		buyerIncomeInterval:"IncomeInterval",
		coBuyerHousingCostCents:"BigInt",
		coBuyerIncomeCents:"BigInt",
		coBuyerIncomeInterval:"IncomeInterval",
		createdAt:"DateTime",
		id:"String",
		transactionId:"String",
		updatedAt:"DateTime"
	},
	LicensePrefillData:{
		make:"String",
		model:"String",
		trim:"String",
		vin:"String",
		year:"String"
	},
	ListItem:{
		label:"String",
		value:"String"
	},
	LivelinessSession:{
		auditImages:"File",
		awsLivelinessSessionId:"String",
		confidence:"Float",
		createdAt:"DateTime",
		dealership:"Dealership",
		dealershipId:"String",
		id:"String",
		referenceImage:"File",
		status:"String",
		transaction:"Transaction",
		transactionId:"String",
		upddatedAt:"DateTime",
		user:"User",
		userId:"String"
	},
	LoginResponse:{
		jwt:"String"
	},
	MakeFileUploadForScannerType:{
		fileId:"String",
		uploadUrl:"String"
	},
	MakeFileUploadType:{
		file:"File",
		fileId:"String",
		uploadUrl:"String"
	},
	MeType:{
		chats:"MeTypeChatsConnection",
		dealershipGroup:"DealershipGroup",
		dealerships:"Dealership",
		ipAddress:"String",
		staffAt:"DealershipPermType",
		user:"User"
	},
	MeTypeChatsConnection:{
		edges:"MeTypeChatsConnectionEdge",
		pageInfo:"PageInfo"
	},
	MeTypeChatsConnectionEdge:{
		cursor:"String",
		node:"Chat"
	},
	Mutation:{
		addScanToDealerJacket:"MutationAddScanToDealerJacketResult",
		addScanToGloveCompartments:"MutationAddScanToGloveCompartmentsResult",
		assignStaffToTransaction:"MutationAssignStaffToTransactionResult",
		cancelFormCollection:"MutationCancelFormCollectionResult",
		cancelPreviousAndRequestSignatures:"MutationCancelPreviousAndRequestSignaturesResult",
		changeDocumentAccess:"MutationChangeDocumentAccessResult",
		changeFormSubmissionAccess:"MutationChangeFormSubmissionAccessResult",
		createAndSubmitCreditAndPrequalApplication:"MutationCreateAndSubmitCreditAndPrequalApplicationResult",
		createChat:"MutationCreateChatResult",
		createCoBuyer:"MutationCreateCoBuyerResult",
		createCreditApplicationAndCreateUser:"MutationCreateCreditApplicationAndCreateUserResult",
		createEmployment:"MutationCreateEmploymentResult",
		createGroupuser:"MutationCreateGroupuserResult",
		createStaff:"MutationCreateStaffResult",
		createStaffScheduleEvents:"MutationCreateStaffScheduleEventsResult",
		createTransactionAndSubmitTestDrive:"MutationCreateTransactionAndSubmitTestDriveResult",
		createUserFeedback:"MutationCreateUserFeedbackResult",
		customerCreatePrefilledTransaction:"MutationCustomerCreatePrefilledTransactionResult",
		customerCreatePurchaseVehicle:"MutationCustomerCreatePurchaseVehicleResult",
		customerCreateTradeVehicle:"MutationCustomerCreateTradeVehicleResult",
		customerCreateTransaction:"MutationCustomerCreateTransactionResult",
		customerCreateUnauthenticatedTransaction:"MutationCustomerCreateUnauthenticatedTransactionResult",
		customerReferral:"MutationCustomerReferralResult",
		customerReferralPaid:"MutationCustomerReferralPaidResult",
		customerSignupWithCognito:"MutationCustomerSignupWithCognitoResult",
		customerUpdatePhoneNumber:"MutationCustomerUpdatePhoneNumberResult",
		customerUpdatePurchaseVehicle:"MutationCustomerUpdatePurchaseVehicleResult",
		customerUpdateTradeVehicle:"MutationCustomerUpdateTradeVehicleResult",
		dealershipCreatePurchaseVehicle:"MutationDealershipCreatePurchaseVehicleResult",
		dealershipCreateTradeVehicle:"MutationDealershipCreateTradeVehicleResult",
		dealershipCreateTransaction:"MutationDealershipCreateTransactionResult",
		dealershipRemoveTradeVehicle:"MutationDealershipRemoveTradeVehicleResult",
		dealershipUpdatePurchaseVehicle:"MutationDealershipUpdatePurchaseVehicleResult",
		dealershipUpdateTradeVehicle:"MutationDealershipUpdateTradeVehicleResult",
		deleteStaffScheduleEvent:"MutationDeleteStaffScheduleEventResult",
		dismissNotifications:"MutationDismissNotificationsResult",
		extractVehicleFromRegistration:"MutationExtractVehicleFromRegistrationResult",
		fetchAgilityCreditPrequalReportHtml:"MutationFetchAgilityCreditPrequalReportHtmlResult",
		finalizeLivenessAnalysis:"MutationFinalizeLivenessAnalysisResult",
		login:"MutationLoginResult",
		logout:"MutationLogoutResult",
		makeSubmissionToken:"MutationMakeSubmissionTokenResult",
		makeUpload:"MutationMakeUploadResult",
		makeUploadForScanner:"MutationMakeUploadForScannerResult",
		makeUploadToTransaction:"MutationMakeUploadToTransactionResult",
		markTransactionAsDelivered:"MutationMarkTransactionAsDeliveredResult",
		modifyHardCreditApplication:"MutationModifyHardCreditApplicationResult",
		onboardingSubmitStep1:"MutationOnboardingSubmitStep1Result",
		onboardingSubmitStep2:"MutationOnboardingSubmitStep2Result",
		overrideTodo:"MutationOverrideTodoResult",
		preLoginCheck:"MutationPreLoginCheckResult",
		prefillLicensePlateOrVin:"MutationPrefillLicensePlateOrVinResult",
		pushDataToCrms:"MutationPushDataToCrmsResult",
		pushDocumentToCdkDealJacket:"MutationPushDocumentToCdkDealJacketResult",
		pushDocumentsToCdk:"MutationPushDocumentsToCdkResult",
		pushFormSubmissionsToCdk:"MutationPushFormSubmissionsToCdkResult",
		pushHardCreditApplication:"MutationPushHardCreditApplicationResult",
		recordChatNavigation:"MutationRecordChatNavigationResult",
		recordConsent:"MutationRecordConsentResult",
		removeCoBuyer:"MutationRemoveCoBuyerResult",
		removePrimaryBuyer:"MutationRemovePrimaryBuyerResult",
		requestAgilityCreditOfac:"MutationRequestAgilityCreditOfacResult",
		requestAgilityCreditOow:"MutationRequestAgilityCreditOowResult",
		requestAgilityCreditPrequal:"MutationRequestAgilityCreditPrequalResult",
		requestAgilityCreditRedFlags:"MutationRequestAgilityCreditRedFlagsResult",
		requestIdentityVerification:"MutationRequestIdentityVerificationResult",
		requestOtpExistingUserDEV:"MutationRequestOtpExistingUserDEVResult",
		requestPrequalReports:"MutationRequestPrequalReportsResult",
		requestPrescreen:"MutationRequestPrescreenResult",
		resendStaffPassword:"MutationResendStaffPasswordResult",
		resolveStagedAction:"MutationResolveStagedActionResult",
		saveLendingPortalCustomerData:"MutationSaveLendingPortalCustomerDataResult",
		saveLendingPortalPurchaseVehicleData:"MutationSaveLendingPortalPurchaseVehicleDataResult",
		saveLendingPortalTradeVehicleData:"MutationSaveLendingPortalTradeVehicleDataResult",
		sendChatMessage:"MutationSendChatMessageResult",
		sendFormReadyNotifications:"MutationSendFormReadyNotificationsResult",
		setDeliveryMethodForUser:"MutationSetDeliveryMethodForUserResult",
		setDocumentLabels:"MutationSetDocumentLabelsResult",
		setDocumentTitle:"MutationSetDocumentTitleResult",
		setStaffInformation:"MutationSetStaffInformationResult",
		setStaffPlanningEnabled:"MutationSetStaffPlanningEnabledResult",
		stageAdditionalForms:"MutationStageAdditionalFormsResult",
		startLivenessAnalysis:"MutationStartLivenessAnalysisResult",
		submitAgilityCreditOowAnswers:"MutationSubmitAgilityCreditOowAnswersResult",
		submitFormValues:"MutationSubmitFormValuesResult",
		submitPrequalApplicationAndCreateUser:"MutationSubmitPrequalApplicationAndCreateUserResult",
		submitPrequalApplicationOnTransaction:"MutationSubmitPrequalApplicationOnTransactionResult",
		submitStaffAcknowledgement:"MutationSubmitStaffAcknowledgementResult",
		submitStandardForm:"MutationSubmitStandardFormResult",
		suspendGroupUser:"MutationSuspendGroupUserResult",
		suspendStaff:"MutationSuspendStaffResult",
		switchCustomerRoles:"MutationSwitchCustomerRolesResult",
		testDriveEnsureCustomerForDealership:"MutationTestDriveEnsureCustomerForDealershipResult",
		trackUserEvent:"MutationTrackUserEventResult",
		unlockTransaction:"MutationUnlockTransactionResult",
		updateCustomer:"MutationUpdateCustomerResult",
		updateEmployment:"MutationUpdateEmploymentResult",
		updateGroupUser:"MutationUpdateGroupUserResult",
		updateIdCardRotation:"MutationUpdateIdCardRotationResult",
		updateMyUser:"MutationUpdateMyUserResult",
		updateReceivesAuthenticomReport:"MutationUpdateReceivesAuthenticomReportResult",
		updateStaffAttributes:"MutationUpdateStaffAttributesResult",
		updateStaffExtraPermissions:"MutationUpdateStaffExtraPermissionsResult",
		updateStaffScheduleEvent:"MutationUpdateStaffScheduleEventResult",
		updateTradeVehicleIntent:"MutationUpdateTradeVehicleIntentResult",
		updateTransaction:"MutationUpdateTransactionResult",
		uploadAdditionalDocuments:"MutationUploadAdditionalDocumentsResult",
		uploadAdditionalDocumentsToTransaction:"MutationUploadAdditionalDocumentsToTransactionResult",
		uploadIdCard:"MutationUploadIdCardResult",
		uploadIdCardWithToken:"MutationUploadIdCardWithTokenResult",
		userExists:"MutationUserExistsResult",
		verifyOtpForExistingUser:"MutationVerifyOtpForExistingUserResult"
	},
	MutationAddScanToDealerJacketResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationAddScanToDealerJacketSuccess":"MutationAddScanToDealerJacketSuccess"
	},
	MutationAddScanToDealerJacketSuccess:{
		data:"MutationResponse"
	},
	MutationAddScanToGloveCompartmentsResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationAddScanToGloveCompartmentsSuccess":"MutationAddScanToGloveCompartmentsSuccess"
	},
	MutationAddScanToGloveCompartmentsSuccess:{
		data:"MutationResponse"
	},
	MutationAssignStaffToTransactionResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationAssignStaffToTransactionSuccess":"MutationAssignStaffToTransactionSuccess"
	},
	MutationAssignStaffToTransactionSuccess:{
		data:"Response"
	},
	MutationCancelFormCollectionResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCancelFormCollectionSuccess":"MutationCancelFormCollectionSuccess"
	},
	MutationCancelFormCollectionSuccess:{
		data:"MutationResponse"
	},
	MutationCancelPreviousAndRequestSignaturesResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCancelPreviousAndRequestSignaturesSuccess":"MutationCancelPreviousAndRequestSignaturesSuccess"
	},
	MutationCancelPreviousAndRequestSignaturesSuccess:{
		data:"MutationResponse"
	},
	MutationChangeDocumentAccessResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationChangeDocumentAccessSuccess":"MutationChangeDocumentAccessSuccess"
	},
	MutationChangeDocumentAccessSuccess:{
		data:"MutationResponse"
	},
	MutationChangeFormSubmissionAccessResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationChangeFormSubmissionAccessSuccess":"MutationChangeFormSubmissionAccessSuccess"
	},
	MutationChangeFormSubmissionAccessSuccess:{
		data:"MutationResponse"
	},
	MutationCreateAndSubmitCreditAndPrequalApplicationResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCreateAndSubmitCreditAndPrequalApplicationSuccess":"MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"
	},
	MutationCreateAndSubmitCreditAndPrequalApplicationSuccess:{
		data:"Response"
	},
	MutationCreateChatResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCreateChatSuccess":"MutationCreateChatSuccess"
	},
	MutationCreateChatSuccess:{
		data:"MutationResponseWithId"
	},
	MutationCreateCoBuyerResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCreateCoBuyerSuccess":"MutationCreateCoBuyerSuccess"
	},
	MutationCreateCoBuyerSuccess:{
		data:"MutationResponse"
	},
	MutationCreateCreditApplicationAndCreateUserResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCreateCreditApplicationAndCreateUserSuccess":"MutationCreateCreditApplicationAndCreateUserSuccess"
	},
	MutationCreateCreditApplicationAndCreateUserSuccess:{
		data:"Response"
	},
	MutationCreateEmploymentResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCreateEmploymentSuccess":"MutationCreateEmploymentSuccess"
	},
	MutationCreateEmploymentSuccess:{
		data:"MutationResponseWithId"
	},
	MutationCreateGroupuserResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCreateGroupuserSuccess":"MutationCreateGroupuserSuccess"
	},
	MutationCreateGroupuserSuccess:{
		data:"MutationResponseWithId"
	},
	MutationCreateStaffResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCreateStaffSuccess":"MutationCreateStaffSuccess"
	},
	MutationCreateStaffScheduleEventsResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCreateStaffScheduleEventsSuccess":"MutationCreateStaffScheduleEventsSuccess"
	},
	MutationCreateStaffScheduleEventsSuccess:{
		data:"MutationResponse"
	},
	MutationCreateStaffSuccess:{
		data:"User"
	},
	MutationCreateTransactionAndSubmitTestDriveResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCreateTransactionAndSubmitTestDriveSuccess":"MutationCreateTransactionAndSubmitTestDriveSuccess"
	},
	MutationCreateTransactionAndSubmitTestDriveSuccess:{
		data:"MutationResponseWithId"
	},
	MutationCreateUserFeedbackResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCreateUserFeedbackSuccess":"MutationCreateUserFeedbackSuccess"
	},
	MutationCreateUserFeedbackSuccess:{
		data:"MutationResponse"
	},
	MutationCustomerCreatePrefilledTransactionResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCustomerCreatePrefilledTransactionSuccess":"MutationCustomerCreatePrefilledTransactionSuccess"
	},
	MutationCustomerCreatePrefilledTransactionSuccess:{
		data:"MutationResponseWithId"
	},
	MutationCustomerCreatePurchaseVehicleResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCustomerCreatePurchaseVehicleSuccess":"MutationCustomerCreatePurchaseVehicleSuccess"
	},
	MutationCustomerCreatePurchaseVehicleSuccess:{
		data:"MutationResponseWithId"
	},
	MutationCustomerCreateTradeVehicleResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCustomerCreateTradeVehicleSuccess":"MutationCustomerCreateTradeVehicleSuccess"
	},
	MutationCustomerCreateTradeVehicleSuccess:{
		data:"MutationResponseWithId"
	},
	MutationCustomerCreateTransactionResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCustomerCreateTransactionSuccess":"MutationCustomerCreateTransactionSuccess"
	},
	MutationCustomerCreateTransactionSuccess:{
		data:"MutationResponseWithId"
	},
	MutationCustomerCreateUnauthenticatedTransactionResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCustomerCreateUnauthenticatedTransactionSuccess":"MutationCustomerCreateUnauthenticatedTransactionSuccess"
	},
	MutationCustomerCreateUnauthenticatedTransactionSuccess:{
		data:"MutationResponseWithId"
	},
	MutationCustomerReferralPaidResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCustomerReferralPaidSuccess":"MutationCustomerReferralPaidSuccess"
	},
	MutationCustomerReferralPaidSuccess:{
		data:"Response"
	},
	MutationCustomerReferralResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCustomerReferralSuccess":"MutationCustomerReferralSuccess"
	},
	MutationCustomerReferralSuccess:{
		data:"Response"
	},
	MutationCustomerSignupWithCognitoResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCustomerSignupWithCognitoSuccess":"MutationCustomerSignupWithCognitoSuccess"
	},
	MutationCustomerSignupWithCognitoSuccess:{
		data:"MutationResponse"
	},
	MutationCustomerUpdatePhoneNumberResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCustomerUpdatePhoneNumberSuccess":"MutationCustomerUpdatePhoneNumberSuccess"
	},
	MutationCustomerUpdatePhoneNumberSuccess:{
		data:"MutationResponse"
	},
	MutationCustomerUpdatePurchaseVehicleResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCustomerUpdatePurchaseVehicleSuccess":"MutationCustomerUpdatePurchaseVehicleSuccess"
	},
	MutationCustomerUpdatePurchaseVehicleSuccess:{
		data:"MutationResponseWithId"
	},
	MutationCustomerUpdateTradeVehicleResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationCustomerUpdateTradeVehicleSuccess":"MutationCustomerUpdateTradeVehicleSuccess"
	},
	MutationCustomerUpdateTradeVehicleSuccess:{
		data:"MutationResponseWithId"
	},
	MutationDealershipCreatePurchaseVehicleResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationDealershipCreatePurchaseVehicleSuccess":"MutationDealershipCreatePurchaseVehicleSuccess"
	},
	MutationDealershipCreatePurchaseVehicleSuccess:{
		data:"MutationResponseWithId"
	},
	MutationDealershipCreateTradeVehicleResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationDealershipCreateTradeVehicleSuccess":"MutationDealershipCreateTradeVehicleSuccess"
	},
	MutationDealershipCreateTradeVehicleSuccess:{
		data:"MutationResponseWithId"
	},
	MutationDealershipCreateTransactionResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationDealershipCreateTransactionSuccess":"MutationDealershipCreateTransactionSuccess"
	},
	MutationDealershipCreateTransactionSuccess:{
		data:"MutationResponseWithId"
	},
	MutationDealershipRemoveTradeVehicleResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationDealershipRemoveTradeVehicleSuccess":"MutationDealershipRemoveTradeVehicleSuccess"
	},
	MutationDealershipRemoveTradeVehicleSuccess:{
		data:"MutationResponseWithId"
	},
	MutationDealershipUpdatePurchaseVehicleResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationDealershipUpdatePurchaseVehicleSuccess":"MutationDealershipUpdatePurchaseVehicleSuccess"
	},
	MutationDealershipUpdatePurchaseVehicleSuccess:{
		data:"MutationResponseWithId"
	},
	MutationDealershipUpdateTradeVehicleResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationDealershipUpdateTradeVehicleSuccess":"MutationDealershipUpdateTradeVehicleSuccess"
	},
	MutationDealershipUpdateTradeVehicleSuccess:{
		data:"MutationResponseWithId"
	},
	MutationDeleteStaffScheduleEventResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationDeleteStaffScheduleEventSuccess":"MutationDeleteStaffScheduleEventSuccess"
	},
	MutationDeleteStaffScheduleEventSuccess:{
		data:"MutationResponse"
	},
	MutationDismissNotificationsResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationDismissNotificationsSuccess":"MutationDismissNotificationsSuccess"
	},
	MutationDismissNotificationsSuccess:{
		data:"MutationResponse"
	},
	MutationExtractVehicleFromRegistrationResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationExtractVehicleFromRegistrationSuccess":"MutationExtractVehicleFromRegistrationSuccess"
	},
	MutationExtractVehicleFromRegistrationSuccess:{
		data:"MutationResponseWithId"
	},
	MutationFetchAgilityCreditPrequalReportHtmlResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationFetchAgilityCreditPrequalReportHtmlSuccess":"MutationFetchAgilityCreditPrequalReportHtmlSuccess"
	},
	MutationFetchAgilityCreditPrequalReportHtmlSuccess:{
		data:"AgilityCreditReportHtml"
	},
	MutationFinalizeLivenessAnalysisResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationFinalizeLivenessAnalysisSuccess":"MutationFinalizeLivenessAnalysisSuccess"
	},
	MutationFinalizeLivenessAnalysisSuccess:{
		data:"MutationResponseWithId"
	},
	MutationLoginResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationLoginSuccess":"MutationLoginSuccess"
	},
	MutationLoginSuccess:{
		data:"LoginResponse"
	},
	MutationLogoutResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationLogoutSuccess":"MutationLogoutSuccess"
	},
	MutationLogoutSuccess:{
		data:"MutationResponse"
	},
	MutationMakeSubmissionTokenResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationMakeSubmissionTokenSuccess":"MutationMakeSubmissionTokenSuccess"
	},
	MutationMakeSubmissionTokenSuccess:{
		data:"String"
	},
	MutationMakeUploadForScannerResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationMakeUploadForScannerSuccess":"MutationMakeUploadForScannerSuccess"
	},
	MutationMakeUploadForScannerSuccess:{
		data:"MakeFileUploadForScannerType"
	},
	MutationMakeUploadResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationMakeUploadSuccess":"MutationMakeUploadSuccess"
	},
	MutationMakeUploadSuccess:{
		data:"MakeFileUploadType"
	},
	MutationMakeUploadToTransactionResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationMakeUploadToTransactionSuccess":"MutationMakeUploadToTransactionSuccess"
	},
	MutationMakeUploadToTransactionSuccess:{
		data:"MakeFileUploadType"
	},
	MutationMarkTransactionAsDeliveredResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationMarkTransactionAsDeliveredSuccess":"MutationMarkTransactionAsDeliveredSuccess"
	},
	MutationMarkTransactionAsDeliveredSuccess:{
		data:"MutationResponse"
	},
	MutationModifyHardCreditApplicationResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationModifyHardCreditApplicationSuccess":"MutationModifyHardCreditApplicationSuccess"
	},
	MutationModifyHardCreditApplicationSuccess:{
		data:"Response"
	},
	MutationOnboardingSubmitStep1Result:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationOnboardingSubmitStep1Success":"MutationOnboardingSubmitStep1Success"
	},
	MutationOnboardingSubmitStep1Success:{
		data:"MutationResponse"
	},
	MutationOnboardingSubmitStep2Result:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationOnboardingSubmitStep2Success":"MutationOnboardingSubmitStep2Success"
	},
	MutationOnboardingSubmitStep2Success:{
		data:"MutationResponse"
	},
	MutationOverrideTodoResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationOverrideTodoSuccess":"MutationOverrideTodoSuccess"
	},
	MutationOverrideTodoSuccess:{
		data:"MutationResponse"
	},
	MutationPreLoginCheckResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationPreLoginCheckSuccess":"MutationPreLoginCheckSuccess"
	},
	MutationPreLoginCheckSuccess:{
		data:"PreLoginType"
	},
	MutationPrefillLicensePlateOrVinResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationPrefillLicensePlateOrVinSuccess":"MutationPrefillLicensePlateOrVinSuccess"
	},
	MutationPrefillLicensePlateOrVinSuccess:{
		data:"LicensePrefillData"
	},
	MutationPushDataToCrmsResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationPushDataToCrmsSuccess":"MutationPushDataToCrmsSuccess"
	},
	MutationPushDataToCrmsSuccess:{
		data:"MutationResponse"
	},
	MutationPushDocumentToCdkDealJacketResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationPushDocumentToCdkDealJacketSuccess":"MutationPushDocumentToCdkDealJacketSuccess"
	},
	MutationPushDocumentToCdkDealJacketSuccess:{
		data:"Response"
	},
	MutationPushDocumentsToCdkResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationPushDocumentsToCdkSuccess":"MutationPushDocumentsToCdkSuccess"
	},
	MutationPushDocumentsToCdkSuccess:{
		data:"Response"
	},
	MutationPushFormSubmissionsToCdkResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationPushFormSubmissionsToCdkSuccess":"MutationPushFormSubmissionsToCdkSuccess"
	},
	MutationPushFormSubmissionsToCdkSuccess:{
		data:"Response"
	},
	MutationPushHardCreditApplicationResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationPushHardCreditApplicationSuccess":"MutationPushHardCreditApplicationSuccess"
	},
	MutationPushHardCreditApplicationSuccess:{
		data:"Response"
	},
	MutationRecordChatNavigationResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationRecordChatNavigationSuccess":"MutationRecordChatNavigationSuccess"
	},
	MutationRecordChatNavigationSuccess:{
		data:"MutationResponseWithId"
	},
	MutationRecordConsentResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationRecordConsentSuccess":"MutationRecordConsentSuccess"
	},
	MutationRecordConsentSuccess:{
		data:"Response"
	},
	MutationRemoveCoBuyerResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationRemoveCoBuyerSuccess":"MutationRemoveCoBuyerSuccess"
	},
	MutationRemoveCoBuyerSuccess:{
		data:"MutationResponse"
	},
	MutationRemovePrimaryBuyerResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationRemovePrimaryBuyerSuccess":"MutationRemovePrimaryBuyerSuccess"
	},
	MutationRemovePrimaryBuyerSuccess:{
		data:"MutationResponse"
	},
	MutationRequestAgilityCreditOfacResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationRequestAgilityCreditOfacSuccess":"MutationRequestAgilityCreditOfacSuccess"
	},
	MutationRequestAgilityCreditOfacSuccess:{
		data:"MutationResponse"
	},
	MutationRequestAgilityCreditOowResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationRequestAgilityCreditOowSuccess":"MutationRequestAgilityCreditOowSuccess"
	},
	MutationRequestAgilityCreditOowSuccess:{
		data:"MutationResponseWithId"
	},
	MutationRequestAgilityCreditPrequalResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationRequestAgilityCreditPrequalSuccess":"MutationRequestAgilityCreditPrequalSuccess"
	},
	MutationRequestAgilityCreditPrequalSuccess:{
		data:"MutationResponse"
	},
	MutationRequestAgilityCreditRedFlagsResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationRequestAgilityCreditRedFlagsSuccess":"MutationRequestAgilityCreditRedFlagsSuccess"
	},
	MutationRequestAgilityCreditRedFlagsSuccess:{
		data:"MutationResponse"
	},
	MutationRequestIdentityVerificationResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationRequestIdentityVerificationSuccess":"MutationRequestIdentityVerificationSuccess"
	},
	MutationRequestIdentityVerificationSuccess:{
		data:"MutationResponse"
	},
	MutationRequestOtpExistingUserDEVResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationRequestOtpExistingUserDEVSuccess":"MutationRequestOtpExistingUserDEVSuccess"
	},
	MutationRequestOtpExistingUserDEVSuccess:{
		data:"MutationResponse"
	},
	MutationRequestPrequalReportsResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationRequestPrequalReportsSuccess":"MutationRequestPrequalReportsSuccess"
	},
	MutationRequestPrequalReportsSuccess:{
		data:"MutationResponse"
	},
	MutationRequestPrescreenResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationRequestPrescreenSuccess":"MutationRequestPrescreenSuccess"
	},
	MutationRequestPrescreenSuccess:{
		data:"Response"
	},
	MutationResendStaffPasswordResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationResendStaffPasswordSuccess":"MutationResendStaffPasswordSuccess"
	},
	MutationResendStaffPasswordSuccess:{
		data:"MutationResponse"
	},
	MutationResolveStagedActionResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationResolveStagedActionSuccess":"MutationResolveStagedActionSuccess"
	},
	MutationResolveStagedActionSuccess:{
		data:"MutationResponseWithId"
	},
	MutationResponse:{
		status:"String"
	},
	MutationResponseWithId:{
		id:"String",
		status:"String"
	},
	MutationSaveLendingPortalCustomerDataResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSaveLendingPortalCustomerDataSuccess":"MutationSaveLendingPortalCustomerDataSuccess"
	},
	MutationSaveLendingPortalCustomerDataSuccess:{
		data:"Response"
	},
	MutationSaveLendingPortalPurchaseVehicleDataResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSaveLendingPortalPurchaseVehicleDataSuccess":"MutationSaveLendingPortalPurchaseVehicleDataSuccess"
	},
	MutationSaveLendingPortalPurchaseVehicleDataSuccess:{
		data:"Response"
	},
	MutationSaveLendingPortalTradeVehicleDataResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSaveLendingPortalTradeVehicleDataSuccess":"MutationSaveLendingPortalTradeVehicleDataSuccess"
	},
	MutationSaveLendingPortalTradeVehicleDataSuccess:{
		data:"Response"
	},
	MutationSendChatMessageResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSendChatMessageSuccess":"MutationSendChatMessageSuccess"
	},
	MutationSendChatMessageSuccess:{
		data:"MutationResponseWithId"
	},
	MutationSendFormReadyNotificationsResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSendFormReadyNotificationsSuccess":"MutationSendFormReadyNotificationsSuccess"
	},
	MutationSendFormReadyNotificationsSuccess:{
		data:"MutationResponse"
	},
	MutationSetDeliveryMethodForUserResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSetDeliveryMethodForUserSuccess":"MutationSetDeliveryMethodForUserSuccess"
	},
	MutationSetDeliveryMethodForUserSuccess:{
		data:"MutationResponse"
	},
	MutationSetDocumentLabelsResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSetDocumentLabelsSuccess":"MutationSetDocumentLabelsSuccess"
	},
	MutationSetDocumentLabelsSuccess:{
		data:"MutationResponse"
	},
	MutationSetDocumentTitleResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSetDocumentTitleSuccess":"MutationSetDocumentTitleSuccess"
	},
	MutationSetDocumentTitleSuccess:{
		data:"MutationResponse"
	},
	MutationSetStaffInformationResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSetStaffInformationSuccess":"MutationSetStaffInformationSuccess"
	},
	MutationSetStaffInformationSuccess:{
		data:"Response"
	},
	MutationSetStaffPlanningEnabledResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSetStaffPlanningEnabledSuccess":"MutationSetStaffPlanningEnabledSuccess"
	},
	MutationSetStaffPlanningEnabledSuccess:{
		data:"MutationResponse"
	},
	MutationStageAdditionalFormsResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationStageAdditionalFormsSuccess":"MutationStageAdditionalFormsSuccess"
	},
	MutationStageAdditionalFormsSuccess:{
		data:"MutationResponseWithId"
	},
	MutationStartLivenessAnalysisResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationStartLivenessAnalysisSuccess":"MutationStartLivenessAnalysisSuccess"
	},
	MutationStartLivenessAnalysisSuccess:{
		data:"String"
	},
	MutationSubmitAgilityCreditOowAnswersResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSubmitAgilityCreditOowAnswersSuccess":"MutationSubmitAgilityCreditOowAnswersSuccess"
	},
	MutationSubmitAgilityCreditOowAnswersSuccess:{
		data:"MutationResponseWithId"
	},
	MutationSubmitFormValuesResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSubmitFormValuesSuccess":"MutationSubmitFormValuesSuccess"
	},
	MutationSubmitFormValuesSuccess:{
		data:"MutationResponse"
	},
	MutationSubmitPrequalApplicationAndCreateUserResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSubmitPrequalApplicationAndCreateUserSuccess":"MutationSubmitPrequalApplicationAndCreateUserSuccess"
	},
	MutationSubmitPrequalApplicationAndCreateUserSuccess:{
		data:"Response"
	},
	MutationSubmitPrequalApplicationOnTransactionResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSubmitPrequalApplicationOnTransactionSuccess":"MutationSubmitPrequalApplicationOnTransactionSuccess"
	},
	MutationSubmitPrequalApplicationOnTransactionSuccess:{
		data:"Response"
	},
	MutationSubmitStaffAcknowledgementResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSubmitStaffAcknowledgementSuccess":"MutationSubmitStaffAcknowledgementSuccess"
	},
	MutationSubmitStaffAcknowledgementSuccess:{
		data:"Response"
	},
	MutationSubmitStandardFormResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSubmitStandardFormSuccess":"MutationSubmitStandardFormSuccess"
	},
	MutationSubmitStandardFormSuccess:{
		data:"MutationResponseWithId"
	},
	MutationSuspendGroupUserResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSuspendGroupUserSuccess":"MutationSuspendGroupUserSuccess"
	},
	MutationSuspendGroupUserSuccess:{
		data:"MutationResponse"
	},
	MutationSuspendStaffResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSuspendStaffSuccess":"MutationSuspendStaffSuccess"
	},
	MutationSuspendStaffSuccess:{
		data:"MutationResponse"
	},
	MutationSwitchCustomerRolesResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationSwitchCustomerRolesSuccess":"MutationSwitchCustomerRolesSuccess"
	},
	MutationSwitchCustomerRolesSuccess:{
		data:"MutationResponse"
	},
	MutationTestDriveEnsureCustomerForDealershipResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationTestDriveEnsureCustomerForDealershipSuccess":"MutationTestDriveEnsureCustomerForDealershipSuccess"
	},
	MutationTestDriveEnsureCustomerForDealershipSuccess:{
		data:"Response"
	},
	MutationTrackUserEventResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationTrackUserEventSuccess":"MutationTrackUserEventSuccess"
	},
	MutationTrackUserEventSuccess:{
		data:"MutationResponse"
	},
	MutationUnlockTransactionResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUnlockTransactionSuccess":"MutationUnlockTransactionSuccess"
	},
	MutationUnlockTransactionSuccess:{
		data:"MutationResponse"
	},
	MutationUpdateCustomerResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUpdateCustomerSuccess":"MutationUpdateCustomerSuccess"
	},
	MutationUpdateCustomerSuccess:{
		data:"MutationResponse"
	},
	MutationUpdateEmploymentResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUpdateEmploymentSuccess":"MutationUpdateEmploymentSuccess"
	},
	MutationUpdateEmploymentSuccess:{
		data:"MutationResponse"
	},
	MutationUpdateGroupUserResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUpdateGroupUserSuccess":"MutationUpdateGroupUserSuccess"
	},
	MutationUpdateGroupUserSuccess:{
		data:"MutationResponse"
	},
	MutationUpdateIdCardRotationResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUpdateIdCardRotationSuccess":"MutationUpdateIdCardRotationSuccess"
	},
	MutationUpdateIdCardRotationSuccess:{
		data:"MutationResponse"
	},
	MutationUpdateMyUserResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUpdateMyUserSuccess":"MutationUpdateMyUserSuccess"
	},
	MutationUpdateMyUserSuccess:{
		data:"MutationResponse"
	},
	MutationUpdateReceivesAuthenticomReportResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUpdateReceivesAuthenticomReportSuccess":"MutationUpdateReceivesAuthenticomReportSuccess"
	},
	MutationUpdateReceivesAuthenticomReportSuccess:{
		data:"MutationResponse"
	},
	MutationUpdateStaffAttributesResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUpdateStaffAttributesSuccess":"MutationUpdateStaffAttributesSuccess"
	},
	MutationUpdateStaffAttributesSuccess:{
		data:"MutationResponse"
	},
	MutationUpdateStaffExtraPermissionsResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUpdateStaffExtraPermissionsSuccess":"MutationUpdateStaffExtraPermissionsSuccess"
	},
	MutationUpdateStaffExtraPermissionsSuccess:{
		data:"MutationResponse"
	},
	MutationUpdateStaffScheduleEventResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUpdateStaffScheduleEventSuccess":"MutationUpdateStaffScheduleEventSuccess"
	},
	MutationUpdateStaffScheduleEventSuccess:{
		data:"MutationResponse"
	},
	MutationUpdateTradeVehicleIntentResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUpdateTradeVehicleIntentSuccess":"MutationUpdateTradeVehicleIntentSuccess"
	},
	MutationUpdateTradeVehicleIntentSuccess:{
		data:"MutationResponse"
	},
	MutationUpdateTransactionResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUpdateTransactionSuccess":"MutationUpdateTransactionSuccess"
	},
	MutationUpdateTransactionSuccess:{
		data:"Response"
	},
	MutationUploadAdditionalDocumentsResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUploadAdditionalDocumentsSuccess":"MutationUploadAdditionalDocumentsSuccess"
	},
	MutationUploadAdditionalDocumentsSuccess:{
		data:"MutationResponseWithId"
	},
	MutationUploadAdditionalDocumentsToTransactionResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUploadAdditionalDocumentsToTransactionSuccess":"MutationUploadAdditionalDocumentsToTransactionSuccess"
	},
	MutationUploadAdditionalDocumentsToTransactionSuccess:{
		data:"MutationResponseWithId"
	},
	MutationUploadIdCardResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUploadIdCardSuccess":"MutationUploadIdCardSuccess"
	},
	MutationUploadIdCardSuccess:{
		data:"MutationResponseWithId"
	},
	MutationUploadIdCardWithTokenResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUploadIdCardWithTokenSuccess":"MutationUploadIdCardWithTokenSuccess"
	},
	MutationUploadIdCardWithTokenSuccess:{
		data:"MutationResponseWithId"
	},
	MutationUserExistsResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationUserExistsSuccess":"MutationUserExistsSuccess"
	},
	MutationUserExistsSuccess:{
		data:"Boolean"
	},
	MutationVerifyOtpForExistingUserResult:{
		"...on GraphQLError":"GraphQLError",
		"...on MutationVerifyOtpForExistingUserSuccess":"MutationVerifyOtpForExistingUserSuccess"
	},
	MutationVerifyOtpForExistingUserSuccess:{
		data:"LoginResponse"
	},
	Node:{
		"...on UserDealership": "UserDealership",
		id:"ID"
	},
	Notification:{
		announcement:"Announcement",
		createdAt:"DateTime",
		dismissedAt:"DateTime",
		id:"String",
		payload:"JSON"
	},
	OfacCheck:{
		agilityCreditOfacCheck:"AgilityCreditOfacCheck",
		createdAt:"DateTime",
		errorMessage:"String",
		id:"String",
		source:"OfacCheckSource",
		status:"OfacCheckStatus"
	},
	OowCheck:{
		agilityCreditOowCheck:"AgilityCreditOowCheck",
		createdAt:"DateTime",
		errorMessage:"String",
		id:"String",
		source:"OowCheckSource",
		status:"OowCheckStatus"
	},
	PageInfo:{
		endCursor:"String",
		hasNextPage:"Boolean",
		hasPreviousPage:"Boolean",
		startCursor:"String"
	},
	PlatformType:{
		announcements:"PlatformTypeAnnouncementsConnection",
		documentLabels:"PlatformTypeDocumentLabelsConnection",
		faqs:"PlatformTypeFaqsConnection",
		isIpBlocked:"Boolean",
		isUserSuspended:"Boolean"
	},
	PlatformTypeAnnouncementsConnection:{
		edges:"PlatformTypeAnnouncementsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	PlatformTypeAnnouncementsConnectionEdge:{
		cursor:"String",
		node:"Announcement"
	},
	PlatformTypeDocumentLabelsConnection:{
		edges:"PlatformTypeDocumentLabelsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	PlatformTypeDocumentLabelsConnectionEdge:{
		cursor:"String",
		node:"DocumentLabel"
	},
	PlatformTypeFaqsConnection:{
		edges:"PlatformTypeFaqsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	PlatformTypeFaqsConnectionEdge:{
		cursor:"String",
		node:"Faq"
	},
	PreLoginType:{
		hasConsentedToSms:"Boolean",
		loginOptions:"LoginOptionType",
		userExists:"Boolean"
	},
	PrequalApplication:{
		agilityCreditPrequalReports:"PrequalApplicationAgilityCreditPrequalReportsConnection",
		city:"String",
		id:"String",
		prequalResponses:"PrequalApplicationPrequalResponsesConnection",
		state:"String",
		transactionId:"String",
		userId:"String"
	},
	PrequalApplicationAgilityCreditPrequalReportsConnection:{
		edges:"PrequalApplicationAgilityCreditPrequalReportsConnectionEdge",
		pageInfo:"PageInfo"
	},
	PrequalApplicationAgilityCreditPrequalReportsConnectionEdge:{
		cursor:"String",
		node:"AgilityCreditPrequalReport"
	},
	PrequalApplicationPrequalResponsesConnection:{
		edges:"PrequalApplicationPrequalResponsesConnectionEdge",
		pageInfo:"PageInfo"
	},
	PrequalApplicationPrequalResponsesConnectionEdge:{
		cursor:"String",
		node:"SevenHundredCreditPrequalReports"
	},
	Prescreen:{
		id:"String",
		reportUrl:"String",
		score:"String"
	},
	PublicType:{
		acknowledgements:"PublicTypeAcknowledgementsConnection",
		ipAddress:"String",
		platformVersion:"String"
	},
	PublicTypeAcknowledgementsConnection:{
		edges:"PublicTypeAcknowledgementsConnectionEdge",
		pageInfo:"PageInfo"
	},
	PublicTypeAcknowledgementsConnectionEdge:{
		cursor:"String",
		node:"AcknowledgementTemplate"
	},
	Query:{
		customer:"Customer",
		dealership:"Dealership",
		dealershipStaffScheduleEvents:"StaffScheduleEvent",
		me:"MeType",
		node:"Node",
		nodes:"Node",
		platform:"PlatformType",
		public:"PublicType",
		transaction:"Transaction",
		userDealership:"UserDealership"
	},
	RecallMastersRecallReport:{
		createdAt:"DateTime",
		id:"String",
		request:"String",
		response:"JSON",
		updatedAt:"DateTime"
	},
	RedFlag:{
		agilityCreditRedFlagsCheck:"AgilityCreditRedFlagsCheck",
		createdAt:"DateTime",
		errorMsg:"String",
		id:"String",
		source:"RedFlagSource",
		status:"RedFlagStatus"
	},
	Referral:{
		createdAt:"DateTime",
		dealership:"Dealership",
		id:"String",
		pId:"String",
		payoutInCents:"Int",
		referringContact:"ContactV2",
		status:"ReferralStatus",
		title:"String"
	},
	Response:{
		id:"String",
		status:"String"
	},
	SalesRankingGrouppedByMonth:{
		currentMonth:"Int",
		firstName:"String",
		lastMonth:"Int",
		lastName:"String",
		twoMonthsAgo:"Int",
		userId:"String"
	},
	SevenHundredCreditPrequalReports:{
		application:"PrequalApplication",
		id:"String",
		idMatchSummary:"String",
		ofacSummary:"String",
		product:"String",
		quizStatus:"String",
		redFlagSummary:"String",
		reportUrl:"String",
		response:"String",
		resultCode:"String",
		score:"String"
	},
	Staff:{
		dealershipId:"String",
		dealershipRole:"Role",
		firstName:"String",
		hasEnabledStaffPlanning:"Boolean",
		id:"String",
		lastName:"String",
		receivesAuthenticomReport:"Boolean",
		user:"User",
		userId:"String"
	},
	StaffInformation:{
		cdkCrmEmployeeId:"String",
		dealership:"Dealership",
		dealershipId:"String",
		user:"User",
		userId:"String"
	},
	StaffScheduleEvent:{
		createdAt:"DateTime",
		dealershipId:"String",
		endAt:"DateTime",
		id:"String",
		note:"String",
		staffId:"String",
		startAt:"DateTime",
		updatedAt:"DateTime"
	},
	Todo:{
		assignedToUserId:"String",
		createdAt:"DateTime",
		dealershipGroupId:"String",
		dealershipId:"String",
		id:"String",
		status:"TodoStatus",
		transaction:"Transaction",
		transactionId:"String",
		type:"TodoTypes",
		updatedAt:"DateTime"
	},
	Transaction:{
		agilityCreditVerifications:"TransactionAgilityCreditVerificationsConnection",
		bdc:"User",
		buyer:"Customer",
		buyerId:"String",
		cdkDmsDealId:"String",
		coBuyer:"Customer",
		coBuyerId:"String",
		complianceFormsData:"ComplianceFormsData",
		consumerRebatesInUsdCents:"Int",
		createdAt:"DateTime",
		customerSharedData:"CustomerSharedData",
		dealership:"Dealership",
		dealershipCommitment:"String",
		documents:"TransactionDocumentsConnection",
		downPayment:"Int",
		downPaymentInUsdCents:"Int",
		financeType:"String",
		fniManager:"User",
		formSubmissionCollections:"TransactionFormSubmissionCollectionsConnection",
		formSubmissions:"TransactionFormSubmissionsConnection",
		isLeaseBuyOut:"Boolean",
		leaseTermInMonths:"Int",
		lenderHardCreditApplications:"LenderHardCreditApplication",
		lockedReason:"TransactionLockReason",
		logs:"TransactionLogsConnection",
		milesPerYearInLease:"Int",
		monthlyLeasePaymentInUsdCents:"Int",
		pId:"String",
		price:"Int",
		referrals:"TransactionReferralsConnection",
		routeOneApplicationId:"String",
		salesManager:"User",
		salesPerson:"User",
		salesPriceInUsdCents:"Int",
		salesTaxInMiliBsp:"Int",
		source:"TransactionSource",
		status:"TransactionStatus",
		title:"String",
		todos:"TransactionTodosConnection",
		tradeInPriceInUsdCents:"Int",
		tradeVehicle:"Vehicle",
		usersWorkingOnTransaction:"ListItem",
		vehicle:"Vehicle",
		vehicleRegistrationExtractions:"VehicleRegistrationExtraction"
	},
	TransactionAgilityCreditVerificationsConnection:{
		edges:"TransactionAgilityCreditVerificationsConnectionEdge",
		pageInfo:"PageInfo"
	},
	TransactionAgilityCreditVerificationsConnectionEdge:{
		cursor:"String",
		node:"AgilityCreditIdVerification"
	},
	TransactionDocumentsConnection:{
		edges:"TransactionDocumentsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	TransactionDocumentsConnectionEdge:{
		cursor:"String",
		node:"Document"
	},
	TransactionFormSubmissionCollectionsConnection:{
		edges:"TransactionFormSubmissionCollectionsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	TransactionFormSubmissionCollectionsConnectionEdge:{
		cursor:"String",
		node:"FormSubmissionCollection"
	},
	TransactionFormSubmissionsConnection:{
		edges:"TransactionFormSubmissionsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	TransactionFormSubmissionsConnectionEdge:{
		cursor:"String",
		node:"FormSubmission"
	},
	TransactionLog:{
		createdAt:"DateTime",
		event:"JSON",
		eventDescription:"String",
		executingUser:"User",
		id:"String",
		transaction:"Transaction"
	},
	TransactionLogsConnection:{
		edges:"TransactionLogsConnectionEdge",
		pageInfo:"PageInfo"
	},
	TransactionLogsConnectionEdge:{
		cursor:"String",
		node:"TransactionLog"
	},
	TransactionReferralsConnection:{
		edges:"TransactionReferralsConnectionEdge",
		pageInfo:"PageInfo"
	},
	TransactionReferralsConnectionEdge:{
		cursor:"String",
		node:"Referral"
	},
	TransactionTodosConnection:{
		edges:"TransactionTodosConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	TransactionTodosConnectionEdge:{
		cursor:"String",
		node:"Todo"
	},
	User:{
		buyerFor:"UserBuyerForConnection",
		coBuyerFor:"UserCoBuyerForConnection",
		createdAt:"DateTime",
		customers:"UserCustomersConnection",
		email:"String",
		firstName:"String",
		hasReferred:"UserHasReferredConnection",
		id:"String",
		lastName:"String",
		notifications:"UserNotificationsConnection",
		phoneNumber:"String",
		staff:"UserStaffConnection",
		staffInformation:"UserStaffInformationConnection",
		userAcknowledgements:"UserUserAcknowledgementsConnection",
		userGroup:"UserUserGroupConnection",
		userLogs:"UserUserLogsConnection"
	},
	UserAcknowledgement:{
		createdAt:"DateTime",
		id:"String"
	},
	UserBuyerForConnection:{
		edges:"UserBuyerForConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	UserBuyerForConnectionEdge:{
		cursor:"String",
		node:"Transaction"
	},
	UserCoBuyerForConnection:{
		edges:"UserCoBuyerForConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	UserCoBuyerForConnectionEdge:{
		cursor:"String",
		node:"Transaction"
	},
	UserCustomersConnection:{
		edges:"UserCustomersConnectionEdge",
		pageInfo:"PageInfo"
	},
	UserCustomersConnectionEdge:{
		cursor:"String",
		node:"Customer"
	},
	UserDealership:{
		dealership:"Dealership",
		dealershipId:"String",
		extraPermissions:"Permission",
		id:"ID",
		isSuspended:"Boolean",
		role:"String",
		user:"User"
	},
	UserGroup:{
		group:"DealershipGroup",
		groupId:"String",
		id:"String",
		isSuspended:"Boolean",
		role:"String",
		user:"User"
	},
	UserHasReferredConnection:{
		edges:"UserHasReferredConnectionEdge",
		pageInfo:"PageInfo"
	},
	UserHasReferredConnectionEdge:{
		cursor:"String",
		node:"Referral"
	},
	UserLog:{
		createdAt:"DateTime",
		event:"JSON",
		id:"String",
		userId:"String"
	},
	UserNotificationsConnection:{
		edges:"UserNotificationsConnectionEdge",
		pageInfo:"PageInfo",
		totalCount:"Int"
	},
	UserNotificationsConnectionEdge:{
		cursor:"String",
		node:"Notification"
	},
	UserStaffConnection:{
		edges:"UserStaffConnectionEdge",
		pageInfo:"PageInfo"
	},
	UserStaffConnectionEdge:{
		cursor:"String",
		node:"Staff"
	},
	UserStaffInformationConnection:{
		edges:"UserStaffInformationConnectionEdge",
		pageInfo:"PageInfo"
	},
	UserStaffInformationConnectionEdge:{
		cursor:"String",
		node:"StaffInformation"
	},
	UserUserAcknowledgementsConnection:{
		edges:"UserUserAcknowledgementsConnectionEdge",
		pageInfo:"PageInfo"
	},
	UserUserAcknowledgementsConnectionEdge:{
		cursor:"String",
		node:"UserAcknowledgement"
	},
	UserUserGroupConnection:{
		edges:"UserUserGroupConnectionEdge",
		pageInfo:"PageInfo"
	},
	UserUserGroupConnectionEdge:{
		cursor:"String",
		node:"UserGroup"
	},
	UserUserLogsConnection:{
		edges:"UserUserLogsConnectionEdge",
		pageInfo:"PageInfo"
	},
	UserUserLogsConnectionEdge:{
		cursor:"String",
		node:"UserLog"
	},
	Vehicle:{
		bodyType:"VehicleBodyType",
		color:"String",
		condition:"VehicleCondition",
		createdAt:"DateTime",
		id:"String",
		lifeCycleStage:"VehicleLifeCycleStage",
		make:"String",
		mileage:"Int",
		model:"String",
		msrp:"Int",
		pictureBack:"File",
		pictureFront:"File",
		pictureInterior:"File",
		pictureLeftSide:"File",
		pictureOdometer:"File",
		pictureRightSide:"File",
		pictureVinNumber:"File",
		principalPriorUse:"VehiclePrincipalPriorUse",
		recallMastersRecallReports:"VehicleRecallMastersRecallReportsConnection",
		registrationName:"String",
		registrationState:"String",
		stockNumber:"String",
		transactionPurchaseVehicle:"Transaction",
		transactionTradeVehicle:"Transaction",
		trim:"String",
		updatedAt:"DateTime",
		updatedByDealership:"Boolean",
		vehicleRecallChecks:"VehicleVehicleRecallChecksConnection",
		vin:"String",
		vinAuditReports:"VehicleVinAuditReportsConnection",
		year:"String"
	},
	VehicleNhtsaRecallReport:{
		createdAt:"DateTime",
		id:"String",
		response:"JSON",
		updatedAt:"DateTime"
	},
	VehicleRecallMastersRecallReportsConnection:{
		edges:"VehicleRecallMastersRecallReportsConnectionEdge",
		pageInfo:"PageInfo"
	},
	VehicleRecallMastersRecallReportsConnectionEdge:{
		cursor:"String",
		node:"RecallMastersRecallReport"
	},
	VehicleRegistrationExtraction:{
		bodyType:"String",
		color:"String",
		condition:"String",
		createdAt:"DateTime",
		errorMessage:"String",
		id:"String",
		licensePlate:"String",
		make:"String",
		mileage:"String",
		model:"String",
		registrationName:"String",
		registrationState:"String",
		requestedById:"String",
		status:"VehicleRegistrationExtractionStatus",
		vin:"String",
		year:"String"
	},
	VehicleVehicleRecallChecksConnection:{
		edges:"VehicleVehicleRecallChecksConnectionEdge",
		pageInfo:"PageInfo"
	},
	VehicleVehicleRecallChecksConnectionEdge:{
		cursor:"String",
		node:"VehicleNhtsaRecallReport"
	},
	VehicleVinAuditReportsConnection:{
		edges:"VehicleVinAuditReportsConnectionEdge",
		pageInfo:"PageInfo"
	},
	VehicleVinAuditReportsConnectionEdge:{
		cursor:"String",
		node:"VinAuditReport"
	},
	VinAuditReport:{
		createdAt:"DateTime",
		id:"String",
		response:"JSON",
		updatedAt:"DateTime"
	},
	ID: `scalar.ID` as const
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const
}